import { render, staticRenderFns } from "./FinanceRecord.vue?vue&type=template&id=90f5799a&scoped=true&"
import script from "./FinanceRecord.vue?vue&type=script&lang=js&"
export * from "./FinanceRecord.vue?vue&type=script&lang=js&"
import style0 from "./FinanceRecord.vue?vue&type=style&index=0&id=90f5799a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f5799a",
  null
  
)

export default component.exports